import React, { useState } from "react";
import { FiMapPin, FiPhone, FiMail, FiClock, FiSend, FiUser, FiMessageSquare } from "react-icons/fi";
import { FaWhatsapp, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [hoveredCard, setHoveredCard] = useState(null);
  const [isWhatsAppHovered, setIsWhatsAppHovered] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for contacting us! We will get back to you soon.');
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/9900081006', '_blank');
  };

  const contactInfo = [
    {
      icon: FiMapPin,
      title: 'Our Location',
      subtitle: 'Vijayanagar, Bengaluru',
      details: 'MRCR Layout, MC Layout, Vijayanagar, Bengaluru, Karnataka 560040',
      color: '#356575',
      gradient: 'linear-gradient(135deg, #356575 0%, #2d5562 100%)'
    },
    {
      icon: FiPhone,
      title: 'Call Us',
      subtitle: 'Available for support',
      details: '(+91) 99000 81006',
      link: 'tel:+919900081006',
      color: '#356575',
      gradient: 'linear-gradient(135deg, #356575 0%, #2d5562 100%)'
    },
    {
      icon: FiMail,
      title: 'Email Us',
      subtitle: 'We reply within 24 hours',
      details: 'connect@medini.in',
      link: 'mailto:connect@medini.in',
      color: '#356575',
      gradient: 'linear-gradient(135deg, #356575 0%, #2d5562 100%)'
    },
    {
      icon: FiClock,
      title: 'Business Hours',
      subtitle: 'Visit us anytime',
      details: 'Monday - Saturday: 9:00 AM - 8:30 PM\nSunday: Closed',
      color: '#356575',
      gradient: 'linear-gradient(135deg, #356575 0%, #2d5562 100%)'
    }
  ];

  return (
    <div className="contact-page-wrapper">
      {/* Floating WhatsApp Button */}
      <button
        onClick={handleWhatsAppClick}
        onMouseEnter={() => setIsWhatsAppHovered(true)}
        onMouseLeave={() => setIsWhatsAppHovered(false)}
        className={`whatsapp-float-button ${isWhatsAppHovered ? 'hovered' : ''}`}
        aria-label="Contact us on WhatsApp"
      >
        <FaWhatsapp className="whatsapp-icon" />
      </button>

      {/* Hero Section */}
      <div className="contact-hero-section">
        <div className="hero-background-overlay"></div>
        <div className="hero-animated-particles"></div>

        <div className="hero-content-wrapper">
          <h1 className="hero-main-title">Get In Touch</h1>
          <p className="hero-subtitle">
            Have questions about our Bentley courses? We're here to help you start your learning journey.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="contact-main-container">
        {/* Contact Info Cards */}
        <div className="contact-info-grid">
          {contactInfo.map((info, index) => (
            <div
              key={index}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
              className={`contact-info-card ${hoveredCard === index ? 'hovered' : ''}`}
            >
              <div className={`info-icon-wrapper ${hoveredCard === index ? 'hovered' : ''}`}>
                <info.icon className="info-icon" />
              </div>

              <h3 className="info-title">{info.title}</h3>
              <p className="info-subtitle">{info.subtitle}</p>

              {info.link ? (
                <a href={info.link} className="info-link">
                  {info.details}
                </a>
              ) : (
                <p className="info-details">{info.details}</p>
              )}
            </div>
          ))}
        </div>

        {/* Contact Form + Map */}
        <div className="contact-form-map-grid">
          {/* Contact Form */}
          <div className="contact-form-container">
            <div className="form-header">
              <h2 className="form-title">Send Us a Message</h2>
              <p className="form-description">
                Fill out the form and we'll get back to you within 24 hours.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label className="form-label">
                  <FiUser className="label-icon" />
                  Your Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="Enter your full name"
                />
              </div>

              <div className="form-group">
                <label className="form-label">
                  <FiMail className="label-icon" />
                  Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="your.email@example.com"
                />
              </div>

              <div className="form-group">
                <label className="form-label">
                  <FiPhone className="label-icon" />
                  Phone Number
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="+91 XXXXX XXXXX"
                />
              </div>

              <div className="form-group">
                <label className="form-label">
                  <FiMessageSquare className="label-icon" />
                  Your Message
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  className="form-textarea"
                  placeholder="Tell us about your inquiry..."
                />
              </div>

              <button type="submit" className="form-submit-button">
                <FiSend className="submit-icon" />
                Send Message
              </button>
            </form>

            {/* Social Links */}
            <div className="form-social-links">
              <a
                href="https://www.instagram.com/medinitechnologies/"
                className="social-link instagram"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.linkedin.com/company/medinitechnologies/"
                className="social-link linkedin"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedinIn />
              </a>
            </div>
          </div>

          {/* Map */}
          <div className="map-container-wrapper">
            <div className="map-header">
              <h2 className="map-title">Visit Our Office</h2>
              <p className="map-description">
                Come visit us at our Vijayanagar location
              </p>
            </div>
            <div className="map-iframe-wrapper">
              <iframe
                title="Medini Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3756.389242819478!2d77.5365649822572!3d12.970908380531256!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3ddc28f1fc77%3A0x55fded85a4ed8fdf!2sXGCP%2B9J3%2C%20MRCR%20Layout%2C%20Stage%202%2C%20Vijayanagar%2C%20Bengaluru%2C%20Karnataka%20560040!5e1!3m2!1sen!2sin!4v1769143272678!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0, display: 'block' }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;